
export default function runOnceAtIntervalTime({ interval, callback, onFinish }) {
  let isNeedRunCallback = false;
  let isRunCallbackBlocked = false;
  let event = null;
  const runCallback = () => {
    if (isNeedRunCallback) {
      callback(event);
      setTimeout(runCallback, interval);
    } else {
      onFinish && onFinish(event);
      isRunCallbackBlocked = false;
    }
    isNeedRunCallback = false;
  }

  return currentEvent => {
    event = currentEvent;

    if (isRunCallbackBlocked) {
      isNeedRunCallback = true;
    } else {
      isRunCallbackBlocked = true;
      callback(event);
      setTimeout(runCallback, interval);
    }
  }
}
